<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Designation Master</h5>
            </div>
            <div class="basic-contbox">
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Designation Name</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Designation Name" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Short Name</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Short Name" [(ngModel)]="value" />
                    </div>
                </div>

                <div class="grace-btnbox">
                    <ul>
                        <li><a href="javascript:void();"><span></span> Edit</a></li>
                        <li><a href="javascript:void();"><span></span> Save</a></li>
                        <li><a href="javascript:void();"><span></span> Clear</a></li>
                        <li><a href="javascript:void();"><span></span>Close</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="basic-details basic-details3">
            <div class="tabledata">
                <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div>
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Departname</th>
                            <th>Legal Name</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>